const en = {
  withdrawal: 'Withdrawal',
  cashAccount: 'Withdrawal Account',
  change: 'change',
  descriptionOfWithdrawals: 'RMB提现操作说明',
  addbankAccount: 'Add bank card',
  applyforVirtualAccount: 'Apply for a virtual account',
  virtualName: 'Virtual Account Name',
  defaultNameTip:
    'The account name will be synchronized to the pingpong collectionplatform for correspondence. If it is not filled in, the system default name will be used',
  virtualCurrency: 'Virtual Account Currency',
  currencyTip:
    'Please select the currencies supported under this VA account. You can select multiple currencies.',
  addCurrency: 'Add Currency',
  delete: 'Delete Cash Account',
  deleteAccountTip:
    'Your current account will be credited with the money in the payment. Are you sure to delete this account? The money will be credited to the original account.',
  deleteSureTip: 'Are you sure you want to delete this cash account?',
  association:
    'You need to supplement the articles of association,If it is not supplemented,it will not be able to apply for Euro currency successfully. Do you want to continue',
  return: 'return',
  buttonDelete: 'delete',
  goInput: 'To fill in',
  inReview: 'In Review',
  reviewFailed: 'Review Failed',
  reviewPending: 'Under Review',
  modifyBank: 'Modify Bank Account',
  accountInfo: 'Account Information',
  comfirm: 'Comfirm',
  currency: 'Currency',
  bankName: 'Bank Name',
  cardNo: 'Card No.',
  swiftCode: 'swift code',
  bankCode: 'Bank Code',
  bankCountry: 'Bank Country',
  reservedPhoneNo: 'Reserved PhoneNo',
  virtualAccountName: 'Cash Account',
  virtualSuccess: 'Virtual Account created successfully!',
  exceed:
    'The number of virtual accounts can not exceed the number of websites',
  withdrawSuccessful: 'withdraw  successful',
  inputTip: 'Please enter the withdrawal amount',
  settlementAmount: 'Settlement Amount',
  Minimum: 'Minimum withdrawal amount RMB 100',
  settlementNum: 'Your settlement amount now is',
  all: 'ALL',
  withdrawalFee: 'Withdrawal Fee',
  estimatedTransferredAmount: 'Estimated Transferred Amount',
  replacement: 'Replacement of cash account',
  application: 'The application was successful',
  confirmChange: 'Confirm Change',
  cancel: 'Cancel',
  confirm: 'Confirm',
  cancel2: 'Cancel',
  formRules:
    'The amount is greater than the available amount, please confirm and launch again',
  homeIndex: 'Home',
  withdraw: 'Withdraw',
  withdrawTo: 'Withdraw to',
  exchange: 'Exchange',
  group: 'Group',
  availableAmount: 'Available Balance',
  withdrawAmount: 'Withdraw amount',
  totalAmount: 'Total amount',
  fees: 'Fees',
  netAmount: 'Net amount',
  note: 'Note',
  currents: 'Currentz',
  currentsTip: 'The top up amount will be transferred to Currentz, which is used for non-withdrawal purposes such as supplier payments. If only need to withdraw, please proceed with PingPong Checkout to avoid additional fees in Currentz.',
  remark: 'Reference',
  onlySupportUS: 'Sorry, withdrawals to virtual accounts or Currentz accounts are not currently supported. Please switch to a U.S. bank account to proceed with your withdrawal. Thank you for your understanding!'
}

export default en
